import * as ActionType from './actionType';
import * as Services from '../services';

export const initAboutUsPage = (content = ['Hello initApp']) => {
  return {
    type: ActionType.INIT_ABOUTUS,
    content
  };
};

export const getInstagram = () => {
  return async (dispatch) => {
    try {
      const content = await Services.instagram();
      dispatch({
        type: ActionType.GET_INSTAGRAM,
        content
      });
      return content;
    } catch (err) {
      return err;
    }
  };
};

export const initHomePage = () => {
  return async (dispatch) => {
    try {
      const content = await Services.homePage();
      dispatch({
        type: ActionType.INIT_HOMEPAGE,
        content
      });
      return content;
    } catch (err) {
      return err;
    }
  };
};

export const initNews = () => {
  return async (dispatch) => {
    try {
      const content = await Services.newsEvent();
      dispatch({
        type: ActionType.INIT_NEWS_EVENT,
        content
      });
      return content;
    } catch (err) {
      return err;
    }
  };
};

export const initProducts = () => {
  return async (dispatch) => {
    try {
      const content = await Services.products();
      dispatch({
        type: ActionType.INIT_PRODUCTS,
        content
      });
      return content;
    } catch (err) {
      return err;
    }
  };
};

export const initAllPage = () => {
  return async (dispatch) => {
    try {
      const content = await Services.allPage();
      dispatch({
        type: ActionType.INIT_ALL_PAGE,
        content
      });
      return content;
    } catch (err) {
      return err;
    }
  };
};

export const initSettings = () => {
  return async (dispatch) => {
    try {
      const content = await Services.settings();
      dispatch({
        type: ActionType.INIT_SETTINGS,
        content
      });
      return content;
    } catch (err) {
      return err;
    }
  };
};

export const selectPreviewProduct = (data) => {
  return {
    type: ActionType.SELECT_PRODUCT,
    // content: {
    //   en: data
    // }
    content: data
  };
};


export const initAllPageTh = () => {
  return async (dispatch) => {
    try {
      // const content = await Services.allPageTh();
      const content = await Services.allPage('lang=th');
      dispatch({
        type: ActionType.INIT_ALL_PAGE_TH,
        content
      });
      return content;
    } catch (err) {
      return err;
    }
  };
};

export const initNewsTh = () => {
  return async (dispatch) => {
    try {
      // const content = await Services.newsEventTh();
      const content = await Services.newsEvent('lang=th');
      dispatch({
        type: ActionType.INIT_NEWS_EVENT_TH,
        content
      });
      return content;
    } catch (err) {
      return err;
    }
  };
};

export const initProductsTh = () => {
  return async (dispatch) => {
    try {
      // const content = await Services.productsTh();
      const content = await Services.products('lang=th');
      dispatch({
        type: ActionType.INIT_PRODUCTS_TH,
        content
      });
      return content;
    } catch (err) {
      return err;
    }
  };
};

export const initApp = () => {
  return dispatch => [
    // dispatch(initHomePage()),
    // dispatch(getInstagram()),
    dispatch(initNews()),
    dispatch(initProducts()),
    dispatch(initAllPage()),
    dispatch(initSettings()),
    dispatch(initAllPageTh()),
    dispatch(initNewsTh()),
    dispatch(initProductsTh()),
  ];
};



// WEBPACK FOOTER //
// ./src/actions/action.js